import React, { useState, useRef, useEffect } from 'react'
import { FaBars} from 'react-icons/fa'
import { links, social } from './data'
import logo from './logo.png'
import './css/App.css';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import AboutMe from './AboutMe';
import Projects from "./Projects.js"
import Experience from "./Experience.js"
import Contact from "./Contact.js"

function App() {
const [show, setShow] = useState(false)

 const linksContainerRef=useRef(null) 
 const linksRef=useRef(null)
 useEffect(() => {
   const linksHeight=linksRef.current.getBoundingClientRect().height;
   if(show){
    linksContainerRef.current.style.height=`${linksHeight}px`
   }else{
     linksContainerRef.current.style.height=`0px`
   }
    
   
 }, [show])
  return (
    <div className="App">
      <Router  >
            <div >  
              <nav className="test-heading" >
                <div className="nav-center">
                  <div className="nav-header">
                    <img className="logo" src={logo} alt=""></img>
                    <button className="nav-toggle" onClick={()=>setShow(!show)}><FaBars/></button>
                  </div>
                
                  <div className="links-container" ref={linksContainerRef}>
                    <ul className="links" ref={linksRef}>
                      {links.map((item)=>{
                        const {id,url,text}=item;
                        return <li key={id}><a href={url}>{text}</a></li>
                      })}
                    </ul>
                  </div>
          
              
                  <ul className="social-icons">
                    {social.map((item)=>{
                        const {id,url,icon}=item;
                        return <Link to={url} key={id}>{icon}</Link>
                    })}
                  </ul>
                </div>
                </nav>
                
                <hr />
                <Switch>
                <Route exact path='/' component={AboutMe} />
                <Route path='/projects' component={Projects} />
                <Route path='/experience' component={Experience} />
                <Route path='/contact' component={Contact} />
                
                </Switch>
                </div>
      </Router>
    </div>
  );
}

export default App;
